// https://vuex.vuejs.org/en/state.html

export default {
  nombreEmpresa: 'Empresa',
  authStatus: '',
  token: localStorage.getItem('token') || '',
  user: localStorage.getItem('user') || '',
  area:localStorage.getItem('area') || '',
  pinlength:4,
  time:0,
  running_time: false,
  keyboardModel:2,
  antighost: true,
  refreshghost: false,
  operations:[],
  types:[],
  stops:[],
  filtros: {
    tipoMantenimiento: null,
    nombreMantenimiento: null,
    nombreMaquina: null,
    fecha: new Date().toISOString().substring(0, 10),
  },
  tiposEstados: {
    iniciar: 1,
    unirse: 2,
    salirse: 3,
    finalizar: 4,
    asignar: 5,
    pausar: 6
  },
  tiposMantenimiento: [
    {
      text: 'PREVENTIVO',
      value: 1
    },
    {
      text: 'CORRECTIVO',
      value: 2
    },
    {
      text: 'INSPECCIÓN',
      value: 3
    },
    {
      text: 'SERVICIO',
      value: 4
    },
    {
      text: 'CAMBIO DE MOLDE',
      value: 5
    },
    {
      text: 'CAMBIO DE TROQUEL',
      value: 6
    },
  ],
  pausarActividadMtto: true,
}